var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9965 0.000593276C24.1735 -0.00809307 24.3454 0.0790213 24.4417 0.234562L39.1989 24.0739C39.2696 24.1881 39.2909 24.3261 39.2579 24.4562C39.2249 24.5864 39.1404 24.6976 39.0238 24.7643L24.2665 33.2088C24.1831 33.2565 24.0893 33.2781 23.9965 33.2735C23.9037 33.2781 23.8099 33.2565 23.7264 33.2088L8.96919 24.7643C8.85264 24.6976 8.76818 24.5864 8.73517 24.4562C8.70216 24.3261 8.72343 24.1881 8.79411 24.0739L23.5513 0.234562C23.6476 0.0790213 23.8196 -0.00809307 23.9965 0.000593276ZM38.9766 26.8452C39.134 27.0181 39.1491 27.2774 39.0128 27.4673L24.4229 47.7936C24.3233 47.9324 24.1615 48.0075 23.9965 47.9994C23.8315 48.0075 23.6697 47.9324 23.5701 47.7936L8.98018 27.4673C8.84387 27.2774 8.85895 27.0181 9.01634 26.8452C9.17374 26.6724 9.43057 26.6332 9.63235 26.7512L23.9965 35.1512L38.3606 26.7512C38.5624 26.6332 38.8192 26.6724 38.9766 26.8452Z",
    fill: "#1616B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4772 45.966L11.1423 28.7814L23.4772 35.9947V45.966Z",
    fill: "#F0CDC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5159 45.9659V35.9947L36.8507 28.7814L24.5159 45.9659Z",
    fill: "#C9B3F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4773 31.9252L10.3063 24.3884L23.4773 18.4906V31.9252Z",
    fill: "#88AAF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5158 31.9252V18.4906L37.6868 24.3884L24.5158 31.9252Z",
    fill: "#C9B3F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4772 17.4055L10.4854 23.2231L23.4772 2.23553V17.4055Z",
    fill: "#F0CDC2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5159 17.4055V2.23553L37.5077 23.2231L24.5159 17.4055Z",
    fill: "#B8FAF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.79bfeab7b3729d16053b844ea2465912.svg";
export { ForwardRef as ReactComponent };